import { forwardRef, type Ref, type SVGProps } from "react";
const IconFlagOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27.5 5.1a1 1 0 0 0-1 0A16.7 16.7 0 0 1 19.7 7a8.7 8.7 0 0 1-3.2-.8 13.3 13.3 0 0 0-5-1.2A12.7 12.7 0 0 0 6 6.3v-.6a2 2 0 1 0-2 0V29a1 1 0 0 0 2 0v-7.4a10.8 10.8 0 0 1 5.4-1.6 11.4 11.4 0 0 1 4.4 1 10.4 10.4 0 0 0 3.9 1 14.2 14.2 0 0 0 7.9-2.2 1 1 0 0 0 .4-.8V6a1 1 0 0 0-.5-.9M26 18.4a13 13 0 0 1-6.3 1.6 8.7 8.7 0 0 1-3.2-.8 13.3 13.3 0 0 0-5-1.2A12.7 12.7 0 0 0 6 19.3V8.5A11 11 0 0 1 11.4 7a11.4 11.4 0 0 1 4.4 1 10.4 10.4 0 0 0 3.9 1A17.2 17.2 0 0 0 26 7.6z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFlagOutlineSVG);
ForwardRef.displayName = "IconFlagOutline";
export { ForwardRef as IconFlagOutline };
